<template>
  <div class="list-item">
    <label class="checkbox-label" v-if="type === 'switch'">
      <input
        type="checkbox"
        :checked="isChecked"
        @change="() => $emit('toggle', market.id)"
        class="checkbox-input"
      />
      <img :src="market.img" alt="" class="market-img" />
      <a-switch
        :checked="isChecked"
        size="small"
        @change="$emit('toggle', market.id)"
      >
        <template #checkedChildren><check-outlined /></template>
        <template #unCheckedChildren><close-outlined /></template>
      </a-switch>
    </label>
    <label
      class="checkbox-label type-checkbox"
      v-else-if="type === 'checkbox' || type === 'onlyIcon'"
    >
      <input
        type="checkbox"
        :checked="isChecked"
        @change="() => $emit('toggle', market.id)"
        class="checkbox-input"
      />
      <a-badge v-if="showBadge">
        <template #count>
          <ExclamationCircleTwoTone
            style="font-size: 17px"
            two-tone-color="#FF5226"
          />
        </template>
        <img :src="market.img" alt="" class="market-img" />
      </a-badge>
      <img v-else :src="market.img" alt="" class="market-img" />
      <checkbox-base
        v-if="type === 'checkbox'"
        :modelValue="isChecked"
        @update:modelValue="() => $emit('toggle', market.id)"
        type="checkbox"
        grey
      />
    </label>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
import { type MarketCheckbox } from "@/components/UI/MarketsCheckbox/MarketsCheckbox.vue";
import {
  CheckOutlined,
  CloseOutlined,
  ExclamationCircleTwoTone,
} from "@ant-design/icons-vue";
import CheckboxBase from "@/components/UI/CheckboxBase.vue";

defineProps<{
  market: MarketCheckbox;
  isChecked: boolean;
  type: "switch" | "checkbox" | "onlyIcon";
  showBadge?: boolean;
}>();
</script>

<style scoped lang="scss">
.list-item {
  //box-shadow: 0px 6px 11px 0px rgba(0, 0, 0, 0.1);
}

.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-direction: column;
  gap: 2px;
  &.type-checkbox {
    flex-direction: row;
    & .label {
      margin-left: -4px;
      min-width: 27px;
      border-radius: 0 7px 7px 0px;
    }
  }
}

.checkbox-input {
  display: none; /* Скрываем чекбокс */
}

.market-img {
  width: 30px;
  transition: filter 0.3s ease;
  filter: grayscale(100%); /* Чёрно-белое изображение по умолчанию */
  z-index: 5;
}

.checkbox-input:checked + .market-img,
.checkbox-input:checked + span > .market-img {
  filter: none; /* Восстановление нормального цвета при активном чекбоксе */
}
</style>
